module.exports = __webpack_public_path__ + "img/barcode-icon.5ac53850.png";